<script setup lang="ts">
import LabeledReadOnlyText from 'Common/components/elements/data-display/LabeledReadOnlyText.vue'
import type { PlaneInfoType } from 'Modules/types/pages/home/planeInfoType'

interface PropTypes {
  planeInfo: PlaneInfoType
}

const props = defineProps<PropTypes>()
</script>
<template>
  <div
    class="grid grid-rows-[1fr] grid-cols-[1fr_4fr_3fr] content-center bg-slate-200 rounded-md overflow-hidden h-full"
  >
    <div class="h-full">
      <img :src="props.planeInfo.imageUrl" class="object-cover h-full w-full" />
    </div>
    <div class="grid grid-rows-1 grid-cols-[30%_70%] px-10 py-8">
      <LabeledReadOnlyText label="Model">
        {{ props.planeInfo.modelName }}
      </LabeledReadOnlyText>
      <LabeledReadOnlyText label="Tail Number">
        {{ props.planeInfo.tailNumber }}
      </LabeledReadOnlyText>
    </div>
  </div>
</template>
